var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-dialog',{ref:"dialog",attrs:{"text":"保存されていません。\\n変更内容を破棄してページを移動しますか？","okLabel":"変更を破棄","cancelLabel":"キャンセル"}})}
var staticRenderFns = []

export { render, staticRenderFns }